export default "__VITE_ASSET__C$GsCusC__"